import { atom } from 'recoil';
import { MapTypeEnum } from './../enum/mapTypeEnum';

export const MapTypeAppState = atom({
    key: 'MapTypeAppState', // unique ID (with respect to other atoms/selectors)
    default: MapTypeEnum.roadmap, // default value (aka initial value)
});
